import { supabase } from '../../lib/supabase';
import { TwoFactorVerification } from './TwoFactorVerification';
import { setTwoFactorSession, clear2faPendingFlag } from '../../lib/hooks/useTwoFactor';

interface SsoTwoFactorStepProps {
  email: string;
  availableMethods: ('totp' | 'email')[];
  /** Chiamata a verifica riuscita: il chiamante prosegue verso l'app. */
  onVerified: () => void;
}

/**
 * Step 2FA del login SSO (Google/Microsoft): decisione 16 lug 2026, il 2FA
 * del CRM NON viene saltato dall'SSO — dopo il consenso del provider l'utente
 * con 2FA attivo verifica il codice qui (stessa TwoFactorVerification del
 * login password), poi prosegue. "Annulla" = signOut e ritorno al login.
 * Il flag pending è già stato settato dal chiamante (OAuthCallback), quindi
 * un reload a metà verifica fa signOut (stessa semantica del flusso password).
 */
export function SsoTwoFactorStep({ email, availableMethods, onVerified }: SsoTwoFactorStepProps) {
  const handleVerify = (sessionToken: string) => {
    // Stessa durata del flusso password (Login.handleTwoFactorVerify): 24h
    setTwoFactorSession(sessionToken, new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
    clear2faPendingFlag();
    onVerified();
  };

  const handleCancel = async () => {
    clear2faPendingFlag();
    await supabase.auth.signOut({ scope: 'local' });
    window.location.replace('/login');
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="px-6 sm:px-10 pt-8">
        <img src="/logo_colorato.png" alt="Flusia" className="h-8 w-auto object-contain" />
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-8">
        <div className="w-full max-w-sm">
          <TwoFactorVerification
            email={email}
            availableMethods={availableMethods}
            embedded
            onVerify={handleVerify}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </div>
  );
}
